export enum EnrollChanelEnum {
  Web = 'W',
  Mobile = 'M',
}
